import { render, staticRenderFns } from "./Planet.vue?vue&type=template&id=d1b534e4&scoped=true"
import script from "./Planet.vue?vue&type=script&lang=js"
export * from "./Planet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b534e4",
  null
  
)

export default component.exports